import { AccountStateModel } from './models';

export const getRequireLogin = (state: AccountStateModel): boolean => {
  return state.operatorLoginEnabled && state.operator === undefined;
};
